import { cronoszkEVM as viemCronoszkEVM } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const cronoszkEVM = {
  displayName: 'Cronos zkEVM',
  runtime: 'evm',
  viemChain: viemCronoszkEVM,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'cronos-zkevm' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
